/**
 * Light client-side passphrase strength gate, shared by the enrolment (§4.1) and
 * recovery (§4.8) passphrase-set screens. Deliberately simple (no zxcvbn bundle):
 * it only nudges toward length + variety; real entropy protection is Argon2id.
 */
const LABELS = ['Very weak', 'Weak', 'Fair', 'Good', 'Strong', 'Strong'];

export function strength(pw: string): { score: number; label: string } {
  let score = 0;
  if (pw.length >= 12) score += 1;
  if (pw.length >= 16) score += 1;
  if (/[a-z]/u.test(pw) && /[A-Z]/u.test(pw)) score += 1;
  if (/\d/u.test(pw)) score += 1;
  if (/[^a-zA-Z0-9]/u.test(pw)) score += 1;
  return { score, label: LABELS[score] ?? 'Strong' };
}

/** The gate both passphrase-set screens enforce before submit. */
export function isTooWeak(pw: string): boolean {
  return pw.length < 12 || strength(pw).score < 2;
}
